import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { featuredTitles } from "@/mocks/titles";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const slides = featuredTitles.slice(0, 5);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [slides.length]);

  const current = slides[index];

  if (!current) {
    return (
      <div className="flex h-[420px] items-center justify-center bg-primary-950 text-background-200">
        暂无影片内容
      </div>
    );
  }

  return (
    <section aria-label="焦点推荐" className="relative w-full overflow-hidden bg-primary-950">
      <div className="relative h-[520px] w-full md:h-[640px]">
        {slides.map((slide, slideIndex) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              slideIndex === index ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={slide.backdrop}
              alt={`${slide.title} 焦点图`}
              className="h-full w-full object-cover object-top"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/55 to-primary-950/10"></div>
        <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-primary-950/70 to-transparent"></div>
        <div className="absolute inset-x-0 bottom-0 h-56 bg-gradient-to-t from-primary-950 to-transparent"></div>

        <div className="relative z-10 mx-auto flex h-full w-full max-w-[1440px] flex-col justify-end px-4 pb-24 md:px-8 md:pb-28">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
            <div key={current.id} className="max-w-2xl animate-fade-up">
              <div className="mb-4 flex flex-wrap items-center gap-2">
                <span className="rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-background-50">
                  焦点推荐
                </span>
                <span className="rounded-md bg-background-50/15 px-2.5 py-1 text-xs text-background-100 backdrop-blur">
                  {current.type === "movie" ? "电影" : "电视剧"}
                </span>
                {current.badge && (
                  <span className="rounded-md border border-secondary-400/50 px-2.5 py-1 text-xs text-secondary-400">
                    {current.badge}
                  </span>
                )}
              </div>
              <p className="mb-2 text-xs tracking-[0.28em] text-background-300">{current.englishTitle}</p>
              <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
                {current.title}
              </h1>
              <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-background-200 md:text-sm">
                <span className="flex items-center gap-1 text-secondary-400">
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  <strong className="font-medium">{current.rating.toFixed(1)}</strong>
                </span>
                <span>{current.year}</span>
                <span>{current.region}</span>
                <span>{current.type === "movie" ? current.duration : current.episodes}</span>
                <span>{current.genres.join(" / ")}</span>
              </div>
              <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
                {current.tagline}
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${current.id}`}
                  className="inline-flex items-center gap-2 rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-primary-950 whitespace-nowrap transition-colors cursor-pointer hover:bg-secondary-400"
                >
                  <i className="ri-play-circle-line text-base" aria-hidden="true"></i>
                  查看详情
                </Link>
                <Link
                  to={`/category/${current.type}`}
                  className="inline-flex items-center gap-2 rounded-md border border-background-200/40 px-5 py-2.5 text-sm text-background-100 whitespace-nowrap transition-colors cursor-pointer hover:bg-background-50/10"
                >
                  更多{current.type === "movie" ? "电影" : "电视剧"}
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <div className="hidden flex-col gap-2 md:flex">
                {slides.map((slide, slideIndex) => (
                  <button
                    key={slide.id}
                    type="button"
                    onClick={() => setIndex(slideIndex)}
                    aria-label={`切换到 ${slide.title}`}
                    className={`h-1 w-10 rounded-full transition-all cursor-pointer ${
                      slideIndex === index ? "bg-secondary-500" : "bg-background-50/30"
                    }`}
                  />
                ))}
              </div>
              <span className="text-xs text-background-300">
                0{index + 1} / 0{slides.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}